import React, {forwardRef} from 'react';
import Card from './../Card/Card';
import './CardSlide.css';
import { Fade, Slide } from 'react-awesome-reveal';
import { Dashboards } from '../../Constants';

const CardSlide = forwardRef((props,ref) => {
  const newLocal = 'content';
  return (
    <div className='Slide' ref={ref}>
      <Fade direction='up' duration={1500} triggerOnce>
        <div className='card-header' id='our-data'>
          <Fade duration={500} delay={1400} triggerOnce><h1> OUR DATA</h1></Fade>
          <p>
            The below data sets and visualizations are created in R Shiny using a variety of packages. They contain our analysis on various tissues such as the human dorsal root ganglion (hDRG) and some comparisons with animal models. We are working on updating our github with the full set of packages we use and instruction manuals. If you have questions you can email us at <a href="mailto:caps@utdallas.edu" className='email-link'>caps@utdallas.edu.</a>
          </p>
        </div>
      </Fade>
        <div className="card-slide">
          {Dashboards[newLocal].map((card, index) => (
            <Card key={index} title={card.title} description={card.description} link={card.link} imageUrl={card.imageUrl}  paperLinks={card.paperLinks}/>
          ))}
        </div>
    </div>

  );
});

export default CardSlide;
